import styled, { css } from 'styled-components';

import { rem } from '../../utils';

export const StyledWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${({ theme }) => `${rem(theme.Spacing.Size.XSmall / 2)}`};
`;

export const StyledKey = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  ${({ theme }) => css`
    min-width: ${rem(theme.Spacing.Size.MediumLarge)};
    border-radius: ${rem(theme.Border.Radius.Small)};
    background: ${theme.Color.Neutrals.Light};
    padding: ${rem(theme.Spacing.Size.XXSmall)};
  `}
`;
